import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { GlobalService } from '../services/global.service';
import { AccessService } from '../services/access.service';

export const crmAdmGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const globalService = inject(GlobalService);
  const accessService = inject(AccessService);
  const router = inject(Router);
  const user = globalService.loggedUserClass;

  if (!authService.isLoggedin(user)) {
    const restoredUser = authService.restoreSession();
    if (restoredUser) {
      globalService.loggedUserClass = restoredUser;
    } else {
      router.navigate(['/login']);
      return false;
    }
  }

  const activeUser = globalService.loggedUserClass;

  // Administradores globais têm acesso direto ao CRM ADM
  if (activeUser?.Admin) {
    return true;
  }

  // Para outros utilizadores, valida a regra 'CRM > Aceder ao CRM'
  try {
    const hasAccess = await accessService.GetUsersAccessValidate('CRM', 'Aceder ao CRM');
    if (hasAccess) {
      return true;
    }
  } catch (e) {
    console.warn('[crmAdmGuard] Erro ao verificar acesso:', e);
  }

  router.navigate(['/home']);
  return false;
};

export const crmMediadorGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const globalService = inject(GlobalService);
  const accessService = inject(AccessService);
  const router = inject(Router);
  const user = globalService.loggedUserClass;

  if (!authService.isLoggedin(user)) {
    const restoredUser = authService.restoreSession();
    if (restoredUser) {
      globalService.loggedUserClass = restoredUser;
    } else {
      router.navigate(['/login']);
      return false;
    }
  }

  const activeUser = globalService.loggedUserClass;

  // Administradores globais têm acesso direto ao CRM Mediador
  if (activeUser?.Admin) {
    return true;
  }

  // Para outros utilizadores, valida via gestão de acessos do sistema se tem a permissão expressa
  try {
    const hasAccess = await accessService.GetUsersAccessValidate('CRM Mediador', 'Aceder ao CRM Mediador');
    if (hasAccess) {
      return true;
    }
  } catch (e) {
    console.warn('[crmMediadorGuard] Erro ao verificar acesso:', e);
  }

  router.navigate(['/home']);
  return false;
};
